import { compact } from 'lodash';
import networkAdapter from '../adapters/network';

export const fetchSeasonForDate = ({ centroidCoordinates, cropId, date, seasonActivityType, userId }) => {
  const [longitude, latitude] = centroidCoordinates;
  const url = compact([
    `/api/season/v1/seasonRules/coordinates/execute?date=${date}`,
    `type=${seasonActivityType}`,
    `longitude=${longitude}`,
    `latitude=${latitude}`,
    cropId ? `cropId=${cropId}` : null
  ]).join('&');
  const legacyOptions = {
    url,
    userId
  };
  
  return networkAdapter({
    legacyOptions
  });
};
